/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions

import useConversation from "../../useConversation";
const baseClassName = styleNames.base;
const componentClassName = 'message';

/**
 * This is the component description.
 */
const Message = ({
  id,
  className: userClassName,
  style,
  message,
  customMessage,
  sender,
  from,
  attachment,
  attachmentIcon,
  attachmentColor
  // ...otherProps
}) => {
  const {
    ourColor,
    theirColor
  } = useConversation();
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName, `x-${from === 'ours' ? ourColor : theirColor}`, from].filter(e => e).join(' '),
    style: style
  }, sender && /*#__PURE__*/React.createElement("p", {
    className: "sender"
  }, sender, ":"), /*#__PURE__*/React.createElement("div", {
    className: "message-content"
  }, customMessage || /*#__PURE__*/React.createElement("p", null, message), attachment && /*#__PURE__*/React.createElement("div", {
    className: `attachment y-${attachmentColor}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, attachmentIcon), /*#__PURE__*/React.createElement("p", null, attachment))));
};
Message.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The message in the conversation
   */
  message: PropTypes.string,
  /**
   * The custom message if it uses more complex html
   */
  customMessage: PropTypes.node,
  /**
   * The sender of the message
   */
  sender: PropTypes.string.isRequired,
  /**
   * The owner of the message
   */
  from: PropTypes.oneOf(['ours', 'theirs']),
  /**
   * name of the attachment file
   */
  attachment: PropTypes.string,
  /**
   * source of the attachment icon
   */
  attachmentIcon: PropTypes.string,
  /**
   * background color of the attachment box
   */
  attachmentColor: PropTypes.string
};
Message.defaultProps = {
  from: 'theirs',
  attachmentIcon: 'A',
  attachmentColor: 'interactive'
};
export default Message;